import { Dropdown, Icon } from '@wyz/ui';
import { useAuth } from 'react-oidc-context';
import { Link } from 'react-router';
import { Trans } from '~/common/context';
import { useLogout } from '~/common/hooks';

const ProfileDropdown = () => {
  const auth = useAuth();
  const logout = useLogout();

  return (
    <Dropdown.Container navbar={true} as='li'>
      <Dropdown.Toggle
        id='profile-toggler'
        bsPrefix='toggle'
        as={Link}
        to='#!'
        className='p-0 nav-link d-flex align-items-center'
      >
        <Icon icon='account-circle' size='lg' />
      </Dropdown.Toggle>
      <Dropdown.Menu className='dropdown-caret dropdown-menu-card  dropdown-menu-end'>
        <Dropdown.ItemText>
          {auth.user?.profile.family_name} {auth.user?.profile.given_name}
        </Dropdown.ItemText>
        <div className='bg-white rounded-2 py-2 dark__bg-1000'>
          <Dropdown.Item
            as='div'
            role='button'
            onClick={() => logout()}
            id='logout'
          >
            <Trans i18nKey='app.common.navbar.top.profile_dropdown.logout' />
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown.Container>
  );
};

export default ProfileDropdown;
